<app-modal
  [(open)]="open"
  title="Upload Software Update"
  [showCancel]="false"
  (closed)="onClose()">

  <form (ngSubmit)="onSubmit()" class="space-y-4">

    <app-form-field label="JAR File *">
      <input type="file" accept=".jar" (change)="onFileChange($event)"
        class="mt-1 block w-full text-[13px] text-ink-2 file:mr-4 file:py-2 file:px-4 file:rounded-control file:border-0 file:text-[13px] file:font-semibold file:bg-sunken file:text-link hover:file:bg-surface-3">
      @if (file) {
        <p class="text-xs text-ink-3 mt-1">{{ file.name }}</p>
      }
    </app-form-field>

    <app-text-input label="Name *" placeholder="e.g. My Firmware" [(ngModel)]="name" name="name" required />

    <app-text-input label="Version *" placeholder="e.g. 1.0.0" [(ngModel)]="version" name="version" required />

    <app-select label="Display Technology *" [options]="technologies" [(ngModel)]="displayTechnology" name="displayTechnology" />

    <app-form-field label="Description">
      <textarea [(ngModel)]="description" name="description" rows="3"
        class="mt-1 block w-full rounded-control border border-hairline bg-card p-2 text-[13px] text-ink-1"
        placeholder="Optional description"></textarea>
    </app-form-field>

    @if (file) {
      <app-form-field label="MD5 Checksum">
        <p class="mt-1 text-[13px] font-mono text-ink-2">
          @if (isComputingMd5) { <span class="text-ink-3">Computing…</span> }
          @else { {{ md5 }} }
        </p>
      </app-form-field>
    }
  </form>

  <ng-template modalFooter>
    <div class="flex flex-1 items-center justify-end gap-2">
      <button type="button" (click)="onClose()"
        class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken">
        Cancel
      </button>
      <button type="button" (click)="onSubmit()" [disabled]="!isValid"
        class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text disabled:opacity-40 hover:brightness-90">
        Upload
      </button>
    </div>
  </ng-template>
</app-modal>
